import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black text-gray-400 py-10">
      <div className="container mx-auto px-4 text-center" style={{ fontFamily: 'var(--body-font)' }}>
        <span>© copyright 2025, Track And Trail.</span>
      </div>
    </footer>
  );
};

export default Footer;
